// extracted by mini-css-extract-plugin
export var wordContainer = "_rz-0";